import { program } from "../mergeMine";

program.parse(process.argv);
